import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { MainService } from '../service/main.service';
import { ApiUrls } from '../apiRouts';
import { Router } from '@angular/router';
import { LocalStorageService } from '../service/local-storage.service';

@Component({
  selector: 'app-event-donor',
  templateUrl: './event-donor.component.html',
  styleUrl: './event-donor.component.scss'
})
export class EventDonorComponent implements OnInit{
  getEventListMain:any;
  getEventList:any;
  userTypeId:any;

  constructor( 
    private location: Location,
    private mainService: MainService,
    private router: Router,
    private localStorageService: LocalStorageService
  ){
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
  }
  
  ngOnInit(): void {
    this.getEventListData();
  }

  getEventListData(){
   this.mainService.getApi(ApiUrls.eventList).subscribe(res =>{
    this.getEventListMain = res.events;
    this.getEventList = res.events;
   })
  }

  goBackToPrevPage() {
    this.location.back();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getEventList = this.getEventListMain
      return;
    }
    this.getEventList = this.getEventListMain.filter((user: any) => {
      return user.event_name.toLowerCase().includes(filterValue)
    });
  }
 
  goToSubEvent(event_id:any){
    this.router.navigate(["/sub-event-donor/" +event_id]);
  }

}
